/**
 * The following `window.app.env` variables are defined within the env.js file found in the public folder.
 * The design decision allows for the exact same build to be performed across any environment and the host server
 * will provide the env.js file to set the runtime configuration variable values.
 *
 * Any server changes for development should be made in /public/env.js
 */

const AUTHENTICATION_SERVER =
  window && window.app && window.app.env
    ? window.app.env.AUTH_URL
    : "https://cocbaptdead01.co.trinity-health.org";
const APP_API_SERVER =
  window && window.app && window.app.env
    ? window.app.env.API_URL
    : "https://jsonplaceholder.typicode.com";

const BLOCK_MESSAGE =
  window && window.BLOCK_MESSAGE ? window.BLOCK_MESSAGE : false;

const SHOW_FIRST_DAY_OF_MONTH =
  window && window.SHOW_FIRST_DAY_OF_MONTH
    ? window.SHOW_FIRST_DAY_OF_MONTH
    : false;

const SHOW_LAST_DAY_OF_MONTH =
  window && window.SHOW_LAST_DAY_OF_MONTH
    ? window.SHOW_LAST_DAY_OF_MONTH
    : false;

const SERVICENOW_URL =
  window && window.SERVICENOW_URL
    ? window.SERVICENOW_URL
    : "https://trinityprod.service-now.com/nav_to.do?uri=%2Fcom.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D8d8a6ba41b8aa050d86d2f0b234bcb1f";
const ZSCALER_URL =
  window && window.ZSCALER_URL
    ? window.ZSCALER_URL
    : "https://gateway.zscalertwo.net:443/_sm_ctn";
const MS_COPILOT_URL =
  window && window.MS_COPILOT_URL
  ? window.MS_COPILOT_URL
  : "https://m365.cloud.microsoft/";

const config = {
  debugMode: true,
  siteMetadata: {
    title: "Trinity React Starter", // Title that appears in the navigation bar.
    description: "",
    author: `Lance Guldi`,
  },
  blockMessage: BLOCK_MESSAGE,
  emailAddress: "AskCyberSecurity@trinity-health.org",
  server: {
    siteRoot: "/", // Used by the navbar, page configurations, authentication functions, etc. to redirect users to the app root (home page).
  },
  services: {
    servicenowURL: SERVICENOW_URL,
    zScalerUrl: ZSCALER_URL,
    loginService: `${AUTHENTICATION_SERVER}/jwt/login/`, // URL to send login POST request for user authentication.
    tokenValidationService: `${AUTHENTICATION_SERVER}/jwt/validate/`, // URL of endpoint to validate JWT tokens.
    appAPI: `${APP_API_SERVER}`, // API server URL, in this demo app this is the URL to the blog post requests used in the Blog Example.
    msCopilotUrl: MS_COPILOT_URL,
  },
  userStorageKey: "webnotifications", // String name of the user object stored in the session storage.
  /**
   * THIS IS TO BE REMOVED.  TEMPORARILY ADDING THE ADMIN ROLE TO USERS
   * WHO ARE IN A CONFIG PROPERTY CALLED `TEMPORARY_ADMIN_DISPLAY_NAMES`
   * THIS WILL BE REPLACED WITH ROLES RETURNED BY THE AUTHENTICATION SERVICE
   */
  TEMPORARY_ADMIN_DISPLAY_NAMES: ["Lance Guldi"],
};

export default config;
